import React, { useState } from 'react';
import MainMenu from 'modules/app/components/MainMenu';
import StreamContainer from 'modules/app/components/StreamContainer';
import styles from './Page.module.scss';
import BottomMenu from '../BottomMenu';
import ProfileMenu from '../ProfileMenu';
import { useActions } from 'store/useActions';
import { useSelector } from 'react-redux';
import { useTypedSelector } from 'store/useTypedSelector';
import { useLocation } from 'react-router-dom';

type PageProps = {
  activeLink?: string;
  children?: React.ReactNode;
  disableOverflow?: boolean;
  marginBottomNone?: boolean;
};

function Page({
  activeLink,
  children,
  disableOverflow = false,
  marginBottomNone = false,
}: PageProps) {
  const [openProfileMenu, setOpenProfileMenu] = useState(true);
  const { setIsSlideChange } = useActions();
  const { isButtonMenuVisible, isOpenBasket } = useTypedSelector(state => state.postSlice);
  const location = useLocation();

  const shouldShowBottomMenu =
    !location.pathname.startsWith('/profile') &&
    !location.pathname.startsWith('/salon/') && 
    // !location.pathname.startsWith('/other-path/') &&
    isButtonMenuVisible &&
    isOpenBasket; 
  return (
    <StreamContainer>
      <div
        className={`${styles.container} ${disableOverflow ? styles.noOverflow : ''} ${
          marginBottomNone ? styles.marginBottomNone : ''
        }`}
      >
        {/* <MainMenu activeLink={activeLink} /> */}

        <div className={styles.main}>{children}</div>

        {shouldShowBottomMenu && (
          <BottomMenu
            activeLink={activeLink || ''}
            openProfileMenu={openProfileMenu}
            setOpenProfileMenu={setOpenProfileMenu}
          />
        )}
      </div>
    </StreamContainer>
  );
}

export default Page;
